import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { QRProductScanComponent } from './qr-product-scan/qr-product-scan.component';
import { WipComponent } from './wip/wip.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FarmRiseErrorHandler } from './error-handler/farmrise-error-handler';
import { NgxSpinnerModule } from "ngx-spinner";
import { ErrorPageComponent } from './error-page/error-page.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../environments/environment';
import { ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { AngularFireAnalyticsModule } from '@angular/fire/compat/analytics'
import { AngularFireModule } from "@angular/fire/compat";
import { LanguageSelectionComponent } from './language-selection/language-selection.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDialogModule } from '@angular/material/dialog';
import { AppDownloadBottomSheetComponent } from './app-download-bottom-sheet/app-download-bottom-sheet.component';
import { AppDownloadBannerComponent } from './app-download-banner/app-download-banner.component';
import { ImageCarouselComponent } from './image-carousel/image-carousel.component';
import { datadogRum } from '@datadog/browser-rum';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

/**
 * @author Anurag Yadav
 * Here we are initializing the datadog plugin to capture RUM
 *
 * @see @datadog/browser-rum
 * @see https://www.npmjs.com/package/@datadog/browser-rum
 */
datadogRum.init({
  applicationId: environment.datadog.applicationId,
  clientToken: environment.datadog.clientToken,
  site: environment.datadog.site,
  service: environment.datadog.service,
  env: environment.datadog.env,
  sessionSampleRate: environment.datadog.sessionSampleRate,
  sessionReplaySampleRate: environment.datadog.sessionReplaySampleRate,
  trackUserInteractions: environment.datadog.trackUserInteractions,
  trackResources: environment.datadog.trackResources,
  trackLongTasks: environment.datadog.trackLongTasks,
  defaultPrivacyLevel: environment.datadog.defaultPrivacyLevel,
});

@NgModule({
  declarations: [
    AppComponent,
    QRProductScanComponent,
    ErrorPageComponent,
    WipComponent,
    LanguageSelectionComponent,
    AppDownloadBottomSheetComponent,
    AppDownloadBannerComponent,
    ImageCarouselComponent
  ],

  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAnalyticsModule,
    HttpClientModule,
    NgxSpinnerModule,
    MatBottomSheetModule,
    MatDialogModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: ErrorHandler, useClass: FarmRiseErrorHandler },
    ScreenTrackingService, UserTrackingService]
})
export class AppModule { }
